import styled from 'styled-components'

export const Wrapper = styled.div``

export const Column = styled.div`
  svg {
    margin-left: 4px;
    color: #757575;
  }
`

export const TooltipTitle = styled.div`
  text-align: center;
  font-family: 'Roboto';
  a {
    margin-left: 5px;
    color: #bfbfbf;
    text-decoration: underline !important;
  }
`
